import React, { useState, useEffect } from "react";

const LandingLoader = ({ done, onComplete }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (done) return undefined;

    const loadInterval = setInterval(() => {
      setProgress((prev) => {
        const next = prev + Math.random() * 18 + 5;
        return next >= 100 ? 100 : next;
      });
    }, 120);

    return () => clearInterval(loadInterval);
  }, [done]);

  useEffect(() => {
    if (progress < 100 || done) return undefined;
    const timer = setTimeout(() => onComplete?.(), 300);
    return () => clearTimeout(timer);
  }, [progress, done, onComplete]);

  return (
    <div className={`loader${done ? " done" : ""}`}>
      <div className="loader-logo">
        ECOM<span>DROP</span>SHIP
      </div>
      <div className="loader-bar-wrap">
        <div className="loader-bar" style={{ width: `${Math.min(progress, 100)}%` }} />
      </div>
      <div className="loader-num">{Math.floor(Math.min(progress, 100))}%</div>
    </div>
  );
};

export default LandingLoader;
